module.exports = __webpack_public_path__ + "img/img_left.72460f2d.jpg";